import { Chip } from "@mui/material";
import React from "react";

const SelectionChip = React.forwardRef(({ label, value, ...props }, ref) => {
    const prefix = label ? `${String(label).replace(/:\s*$/, '')}:` : null;

    return (
        <Chip
            ref={ref}
            label={
                <>
                    {prefix && <span className="chip-prefix">{prefix}</span>}
                    {value}
                </>
            }
            {...props}
        />
    );
});

export default SelectionChip;
